function stackClear(){this.__data__=new ListCache,this.size=0}var ListCache=require("./_ListCache");module.exports=stackClear;